"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterFill = exports.MeterBar = exports.MeterValue = exports.MeterLabel = exports.Meter = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_aria_components_1 = require("react-aria-components");
var theme_1 = require("../theme");
var Form_1 = require("./Forms/Form");
/**
 * A meter component displays a value within a defined range as a visual indicator.
 * It provides a structured way to show progress or completion status with proper accessibility.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Meter.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-meter--default}
 *
 * @example
 * ```tsx
 * <Meter value={75} maxValue={100}>
 *   <MeterLabel>Progress</MeterLabel>
 *   <MeterValue />
 *   <MeterBar>
 *     <MeterFill percentage={75} />
 *   </MeterBar>
 * </Meter>
 * ```
 *
 * @param value - The current value (controlled). Defaults to 0
 * @param minValue - The smallest value allowed for the input. Defaults to 0
 * @param maxValue - The largest value allowed for the input. Defaults to 100
 * @param formatOptions - The display format of the value label. Defaults to {style: 'percent'}
 * @param valueLabel - The content to display as the value's label (e.g. 1 of 4)
 * @param children - The children of the component. Can be ReactNode or a render function
 * @param className - The CSS className for the element. Can be string or a function
 * @param style - The CSS styles for the element. Can be CSSProperties or a function
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.Meter = (0, styled_1.default)(react_aria_components_1.Meter)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-areas:\n    'label value'\n    'bar bar';\n  grid-template-columns: 1fr auto;\n  gap: 4px;\n  width: 250px;\n  color: ", ";\n"], ["\n  display: grid;\n  grid-template-areas:\n    'label value'\n    'bar bar';\n  grid-template-columns: 1fr auto;\n  gap: 4px;\n  width: 250px;\n  color: ", ";\n"])), theme_1.theme.colors.n900);
exports.MeterLabel = (0, styled_1.default)(Form_1.Label)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  grid-area: label;\n"], ["\n  grid-area: label;\n"])));
exports.MeterValue = styled_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  grid-area: value;\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  grid-area: value;\n  font-size: ", ";\n  line-height: ", ";\n"])), theme_1.theme.fontSizes.body, theme_1.theme.lineHeights.body);
exports.MeterBar = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  grid-area: bar;\n  box-shadow: inset 0px 0px 0px 1px ", ";\n  forced-color-adjust: none;\n  height: 10px;\n  border-radius: 5px;\n  overflow: hidden;\n"], ["\n  grid-area: bar;\n  box-shadow: inset 0px 0px 0px 1px ", ";\n  forced-color-adjust: none;\n  height: 10px;\n  border-radius: 5px;\n  overflow: hidden;\n"])), theme_1.theme.colors.n300);
exports.MeterFill = styled_1.default.div(function (_a) {
    var percentage = _a.percentage;
    return "\n    width: ".concat(percentage, "%;\n    background: ").concat(theme_1.theme.colors.actionPrimary, ";\n    height: 100%;\n");
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Meter.js.map